<template>
    <div class="min-h-screen flex items-center justify-center bg-white dark:bg-gray-950">
        <p class="text-sm text-gray-500 dark:text-gray-400">Connexion en cours...</p>
    </div>
</template>

<script>
export default {
    async created() {
        const token = this.$route.query.token;

        if (!token) {
            this.$router.push({ name: 'Login' });
            return;
        }

        await this.$store.dispatch('auth/impersonate', token).catch(() => {
            this.$toast({
                title: 'Erreur',
                description: "Ce lien de connexion n'est plus valide."
            }, this.$toastError);

            this.$router.push({ name: 'Login' });
        });
    }
};
</script>
